import { Fragment } from 'react'

import { Section, SubTitle } from '@/components/ArticleElement'
import PoliciesLayout from '@/components/Layouts/PoliciesLayout'
import { useLanguage } from '@/hooks/Contexts'

const TermsAndConditions = () => {
  const { terms_conditions: strings } = useLanguage()

  return (
    <PoliciesLayout title='terms_conditions'>
      {strings.titles.map((title, i) => (
        <Fragment key={i}>
          <SubTitle extraCls='mt-4 first:mt-0'>{title}</SubTitle>
          <Section paragraphs={strings.paragraphs[i]} paragraphCls='mt-2' />
        </Fragment>
      ))}
    </PoliciesLayout>
  )
}

export default TermsAndConditions
